import React, { ReactNode } from 'react';
import {
  NavigationButtonProps,
  NavigationButtons,
  RadioButtonOptionsProps,
  RadioOptions,
} from '@molecules/index';
import { ErrorMessages } from '@types';
import { ErrorSummary } from '@atoms/ErrorSummary/ErrorSummary';

export interface BinaryQuestionTemplateProps {
  title: string;
  description?: string | JSX.Element;
  titleClassName?: string;
  radioClassName?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  children?: ReactNode;
  onChange: (result: string) => void;
  options: RadioButtonOptionsProps[];
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const BinaryQuestionTemplate: React.FC<BinaryQuestionTemplateProps> = ({
  title,
  description,
  titleClassName,
  radioClassName,
  errorPath,
  errorMessages,
  onChange,
  options,
  buttonNext,
  buttonPrevious,
  onKeyDown,
  children,
}) => {
  return (
    <div className="flex flex-col">
      <ErrorSummary messages={errorMessages} />
      <RadioOptions
        title={title}
        description={description}
        className={titleClassName}
        radioClassName={radioClassName}
        errorPath={errorPath}
        errorMessages={errorMessages}
        onChange={onChange}
        options={options}
        onKeyDown={onKeyDown}
        isLabelTextTitle={true}
      />
      {children}
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
